import { FC } from "react";
import { Box, Text } from "@mantine/core";
import { Trans } from "react-i18next";

// Hộp hướng dẫn 3 bước lấy mã SmartOTP trên app Javis Biz (bám thiết kế Figma node 20879-4262).
const STEP_KEYS = [
  "SMART_OTP_STEP_1",
  "SMART_OTP_STEP_2",
  "SMART_OTP_STEP_3",
] as const;

const SmartOtpInstructions: FC = () => (
  <Box
    style={{
      width: "100%",
      background: "#DBEAF6",
      borderRadius: 12,
      border: "1px solid #EDEDED",
      padding: 16,
      display: "flex",
      flexDirection: "column",
      gap: 15,
    }}
  >
    {STEP_KEYS.map((key, index) => (
      <Box key={key} style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
        <Box
          style={{
            flexShrink: 0,
            width: 20,
            height: 20,
            borderRadius: "50%",
            background: "#0C68BB",
            color: "#FFFFFF",
            fontSize: 12,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
          }}
        >
          {index + 1}
        </Box>
        <Text style={{ fontSize: 13, color: "#18181B", flex: 1 }}>
          <Trans
            i18nKey={key}
            components={{ b: <b style={{ fontWeight: 600 }} /> }}
          />
        </Text>
      </Box>
    ))}
  </Box>
);

export default SmartOtpInstructions;
